module.exports = __webpack_public_path__ + "img/logo_footer.47796a7f.svg";